export const checkoutUrl = 'https://school-counselor-ready-hub.impultienda.ar/checkout';

export const offerPrice = '27';
export const offerCurrency = 'USD';

export const productMockup =
  'https://cdn.magicpatterns.com/uploads/bewx9qJ2x6R6i37St1ZeUT/Lecciones_listas_para_orientadores_escolares.png';


export const trustStats = [
  { value: '36', label: 'Classroom lessons' },
  { value: '1 + 5', label: 'Book & bonuses' },
  { value: '30 min', label: 'Lesson structure' },
  { value: 'Worldwide', label: 'Authority' },
];

export const problems = [
  {
    icon: 'calendar',
    title: '“What am I teaching tomorrow?”',
    text: 'Between student concerns, parent meetings and classroom visits, planning gets pushed into whatever time is left.',
  },
  {
    icon: 'puzzle',
    title: '“I found an idea. Now I have to build it.”',
    text: 'A story here, an activity there, a worksheet somewhere else — and you still have to tie it all together.',
  },
  {
    icon: 'layers',
    title: '“This worksheet won’t work for both classes.”',
    text: 'Kindergartners and fifth graders need different practice on the same skill.',
  },
  {
    icon: 'mic',
    title: '“How do I open this lesson?”',
    text: 'Without a script, the first minutes depend on improvising in front of the whole class.',
  },
];

export const solutionSteps = [
  { title: 'Choose your lesson', text: 'Pick the topic, read the objective and teaching steps.' },
  { title: 'Print your materials', text: 'Select the K–2 or grades 3–5 worksheet for your class.' },
  { title: 'Teach the plan', text: 'Open with the hook, lead the activity and close with reflection.' },
];

export const audiences = [
  'Elementary school counselors',
  'First-year counselors',
  'Elementary teachers',
  'School-based support staff',
];

export const offerIncluded = [
  '1 complete book · 6 units',
  '36 classroom lessons',
  'Read-aloud scripts',
  'Guided activities',
  'K–2 & grades 3–5 worksheets',
  'Reflection questions & family notes',
  '5 practical bonuses',
  'Suggested 36-week sequence',
];

export const closingWithout = [
  'Searching for a story, an activity and a worksheet every week',
  'Building each lesson from a blank page',
  'Adapting one worksheet for K–2 and grades 3–5',
  'Improvising the opening in front of the class',
];

export const closingWith = [
  '36 lessons in a suggested weekly sequence',
  'A script that tells you what to say',
  'Worksheets ready for K–2 and grades 3–5',
  'Reflection questions, exit checks and family notes',
];
